/* eslint-disable no-unused-vars */
import { Container } from '@mui/material'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import Page from '../../components/Page'
import FormSubmit from '../../components/staff/submitForm/FormSubmit'

export default function SubmitFormPage() {
  return (
    <Page title="Submit Form">
      <Container maxWidth="sm" className="ml-0">
        <HeaderBreadcrumbs
          heading="Submit Form"
          links={[{ name: 'Time Sheet', href: '#' }, { name: 'Submit Form' }]}
        />
        <FormSubmit />
      </Container>
    </Page>
  )
}
